var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuddyBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon_buddybook",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e64f29",
    d: "M1 32.73V1.38L20 7.6l19-6.22v31.35l-19 6.22-19-6.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38 2.76V32l-18 5.9L2 32V2.76l17.38 5.69.62.2.62-.2L38 2.76M40 0L20 6.55 0 0v33.45L20 40l20-6.55V0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.58 17.28a1.76 1.76 0 10-1.76-1.76 1.76 1.76 0 001.76 1.76M23.42 17.28a1.76 1.76 0 10-1.75-1.76 1.76 1.76 0 001.75 1.76M29 21.24c0-.19-.11-.26-1.15-.26h-.09c-1.15 0-1.19.07-1.19.26a6.57 6.57 0 11-13.14 0c0-.19-.11-.26-1.15-.26h-.09C11 21 11 21.05 11 21.24a9 9 0 0018 0"
  })));
}
export default SvgBuddyBook;